<div class="row">
  <div class="col s12 m12">
    <h3 class="center">Linusu Tech Shop</h3>
    <p class="center">
      Welcome to the best tech shop in town! You can buy any PC part you want as
      long as you have money. But remember kids, don't drop your PC component!
    </p>
  </div>
</div>

<div class="row">
  <div class="col s12 center" *ngIf="loading; else notLoading">
    <div class="preloader-wrapper big active">
      <div class="spinner-layer spinner-yellow-only">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div>
        <div class="gap-patch">
          <div class="circle"></div>
        </div>
        <div class="circle-clipper right">
          <div class="circle"></div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #notLoading>
    <div class="col s12 ">
      <div
        class="card-panel card white"
        style="border-left:10px solid #ffee58 "
      >
        <span class="black-text">{{ orders.length }} Collection of Orders</span>
      </div>
    </div>
    <div class="col s12" *ngFor="let order of orders">
      <div class="card" style="margin-top: 2rem;">
        <div class="card-title">
          <h5 style="font-weight: 500;">
            {{ order.totalPrice | currency: "USD":digitsInfo:"1.0-0" }}
          </h5>
          <p
            class="grey-text"
            style="font-weight: 400; margin-top: -7px; font-size: 1rem;"
          >
            By {{ order.customerName }} · {{ order.email }}
          </p>
        </div>
        <div class="card-content grey-text text-darken-4">
          <div
            class="row"
            *ngFor="let item of order.items"
            style="margin-bottom: 10px;"
          >
            <div class="col s12 flexed-row">
              <i class="material-icons left">audiotrack</i>
              <h5 class="header" style="font-size: 1.2rem;">
                {{ item.name }}
                <p class="grey-text" style="font-size: 1rem;">
                  {{ item.category }} ·
                  {{ item.price | currency: "USD":digitsInfo:"1.0-0" }}
                </p>
              </h5>
            </div>
          </div>
        </div>
        <div class="card-action">
          <button
            (click)="onDelete(order)"
            class="btn waves-effect waves-red btn-flat red-text"
          >
            delete
          </button>
          <button
            (click)="edit(order)"
            data-target="modal1"
            class="modal-trigger btn waves-effect waves-light btn-flat black-text"
          >
            edit
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</div>

<div class="fixed-action-btn" *ngIf="isLoggedin">
  <a
    data-target="modal1"
    class="btn-floating btn-large modal-trigger waves-effect waves-light yellow lighten-1 "
  >
    <i class="large material-icons grey-text text-darken-4">playlist_add</i>
  </a>
</div>

<div id="modal1" class="modal modal-fixed-footer">
  <div class="modal-content">
    <h5 style="margin-bottom: 1.6rem;">
      {{ !editing ? "New Order" : "Edit Order" }}
    </h5>
    <div class="row">
      <form class="col s12" [formGroup]="itemsForm">
        <div class="row">
          <div class="input-field col s12 m6">
            <input
              id="playlistname"
              type="text"
              class="validate"
              formControlName="customerName"
              placeholder="Customer Name"
              required
            />
          </div>
          <div class="input-field col s12 m6">
            <input
              id="by"
              type="text"
              class="validate"
              formControlName="email"
              placeholder="Email"
              required
            />
          </div>
        </div>

        <div class="row" formArrayName="items">
          <div
            *ngFor="let play of categoriesControl.controls; let i = index"
            [formGroupName]="i"
          >
            <div class="input-field col s12 m4">
              <select
                class="browser-default"
                formControlName="category"
                (change)="getName(i)"
              >
                <option *ngFor="let cat of categories" [ngValue]="cat">{{
                  cat
                }}</option>
              </select>
            </div>
            <div class="input-field col s12 m3">
              <select
                class="browser-default"
                formControlName="name"
                (change)="getPrice(i)"
              >
                <option *ngFor="let name of setName[i]" [ngValue]="name?.name"
                  >{{ name.name }}
                </option>
              </select>
            </div>
            <div class="input-field col s12 m3 with-span">
              <select class="browser-default" formControlName="price">
                <option [ngValue]="getPathOrFcValue('price', i, true)">{{
                  getPathOrFcValue("price", i, true)
                }}</option>
              </select>
            </div>
            <div class="input-field col s12 m2 with-button">
              <a
                *ngIf="categoriesControl.length > 1"
                (click)="deleteField(i)"
                class="btn-floating btn-small btn-flat waves-effect waves-light red form"
                ><i class="tiny material-icons">remove</i></a
              >
              <a
                *ngIf="i == categoriesControl.length - 1"
                (click)="addField()"
                class="btn-floating btn-small btn-flat waves-effect waves-light indigo form"
                ><i class="tiny material-icons">add</i></a
              >
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <a
      class="modal-close waves-effect waves-red lighten-1 btn-flat"
      (click)="cancel()"
      >cancel</a
    >
    <button
      *ngIf="!editing"
      [disabled]="!itemsForm.valid"
      class="modal-close waves-effect waves-yellow btn-flat"
      (click)="onSubmit()"
    >
      submit
    </button>
    <button
      *ngIf="editing"
      [disabled]="!itemsForm.valid"
      class="modal-close waves-effect waves-yellow btn-flat"
      (click)="onEdit()"
    >
      submit
    </button>
  </div>
</div>
